import styled from 'styled-components'
import { BLACK, NEUTRAL_300, NEUTRAL_100 } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { Status, TRANSACTION_STATUS_COLOR } from '@components/TransactionDetailStatusIcon/TransactionDetailStatusIcon'
import { STATUS_COLOR } from '@constants/transaction'
import { PaymentLinkStatus } from '@components/PaymentLinkTransactionStatusIcon/PaymentLinkTransactionStatusIcon'

export const BaseValue = styled.span`
    display: flex;
    flex: 1;
    font-family: ${INTER.regular};
    color: ${BLACK};
    word-break: break-word;
    white-space: pre-wrap;
    overflow: hidden;
    margin-right: 10px;
`

export const BoldValue = styled(BaseValue)`
    font-family: ${INTER.bold};
`

export const StatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 6px;
`

export const StatusRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`

export const StatusText = styled.span<{ $status: Status }>`
    font-family: ${INTER.semiBold};
    color: ${props => TRANSACTION_STATUS_COLOR[props.$status]};
`

export const PaymentLinkStatusText = styled.span<{ $status: PaymentLinkStatus }>`
    font-family: ${INTER.semiBold};
    color: ${props => STATUS_COLOR[props.$status as keyof typeof STATUS_COLOR]};
`

export const Divider = styled.div`
    width: 100%;
    height: 0.5px;
    margin: 4px 0;
    background-color: ${NEUTRAL_100};
`

export const TitleText = styled.span`
    color: ${NEUTRAL_300};
`

export const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

export const CopyButtonContainer = styled.div`
    flex-shrink: 0;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 1px 0;
`

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
`

export const QRButtonContainer = styled.div`
    display: flex;
`
